const getters = {
  filled: (state) => state.filled,
  processing: (state) => state.processing,
};

export default getters;
